{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "virtual": {
    "itemHeight": 52,
    "display": 0
  },
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Fremdbelegdatum",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "Belegdatum",
              "name": "belegdatum",
              "class": "",
              "titleClass": "hidden",
              "filter": true,
              "sortable": true
            },
            {
              "type": "text",
              "title": "",
              "text": "Neu",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "neuerBeleg",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            },
            {
              "type": "text",
              "title": "",
              "text": "Korr. vorhanden",
              "class": "bg-accent rounded-full px-2 ml-2 whitespace-nowrap",
              "visible": {
                "name": "property",
                "property": "belastungVorhanden",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            },
            {
              "type": "text",
              "title": "",
              "text": "Verbucht",
              "class": "bg-success rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "fibudatum",
                "rule": {
                  "name": "not",
                  "rule": {
                    "name": "empty"
                  }
                }
              }
            }
          ]
        }
      ]
    },
    {
      "type": "entity",
      "title": "Lieferant",
      "name": "lieferant",
      "endpoint": "",
      "format": "{{number}} - {{name}}",
      "class": "font-bold",
      "filter": true,
      "sortable": true
    },
    {
      "type": "entity",
      "title": "Baustelle",
      "name": "lieferadresse",
      "endpoint": "",
      "format": "{{kostenstelle}} - {{name}}",
      "class": "",
      "visible": {
        "name": "property",
        "property": "lieferadresse",
        "rule": {
          "name": "required"
        }
      },
      "filter": true,
      "sortable": true
    },
    {
      "type": "select",
      "name": "kzbelegart",
      "title": "Belegart",
      "options": [
        {
          "value": "R",
          "title": "Eingangsrechnung"
        },
        {
          "value": "G",
          "title": "Gutschrift"
        },
        {
          "value": "E",
          "title": "Buchungsbrief"
        },
        {
          "value": "K",
          "title": "Gekürzte Rechnung"
        },
        {
          "value": "H",
          "title": "Nachbelastung"
        },
        {
          "value": "T",
          "title": "Teilrechnung"
        },
        {
          "value": "U",
          "title": "Schlussrechnung"
        },
        {
          "value": "AR",
          "title": "Ausgangsrechnung"
        }
      ],
      "control": "dropdown",
      "filter": true,
      "sortable": true
    },
    {
      "type": "number",
      "title": "StreckenNr.",
      "name": "belegnummer",
      "filter": true,
      "sortable": true
    },
    {
      "type": "string",
      "title": "FremdbelegNr.",
      "name": "bezugsnummer",
      "filter": true,
      "sortable": true
    },
    {
      "type": "string",
      "title": "Objekt (Projektnummer in TR/SR)",
      "name": "objekt",
      "format": "{{objekt}}",
      "class": ""
    },
    {
      "type": "date",
      "title": "Fälligkeit",
      "name": "faelligkeitsdatum",
      "filter": true,
      "sortable": true
    },
    {
      "type": "currency",
      "title": "Anzuweisender Betrag",
      "name": "zuwachs",
      "codeName": "currency",
      "titleClass": "!text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "zuwachs",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "filter": true,
      "sortable": true
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "titleClass": "!text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "filter": true,
      "sortable": true
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "gesamtIncl",
      "codeName": "currency",
      "titleClass": "!text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamtIncl",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "filter": true,
      "sortable": true
    },
    {
      "type": "action",
      "title": "Herunterladen",
      "control": "button",
      "variant": "outline",
      "action": "onDownload",
      "class": "c row center",
      "titleClass": "!text-center",
      "definition": {
        "type": "icon",
        "icon": "fas fa-cloud-download-alt"
      }
    }
  ]
}
